// src/ui/components/ornateHelpers.ts — Victorian Atelier SVG Accents & Filigree

export function renderCornerFiligree(): string {
  const corner = `<svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 26V7C2 4.23858 4.23858 2 7 2H26" stroke="#C8963E" stroke-width="2.2" stroke-linecap="round"/>
    <path d="M6 19V9C6 7.34315 7.34315 6 9 6H19" stroke="#1A365D" stroke-width="1.2" stroke-opacity="0.5"/>
    <circle cx="6.5" cy="6.5" r="2.2" fill="#E5A93C"/>
  </svg>`;
  return `
    <span class="corner-filigree corner-tl" aria-hidden="true">${corner}</span>
    <span class="corner-filigree corner-tr" aria-hidden="true">${corner}</span>
    <span class="corner-filigree corner-bl" aria-hidden="true">${corner}</span>
    <span class="corner-filigree corner-br" aria-hidden="true">${corner}</span>
  `;
}

export function renderCompassWatermark(): string {
  return `
    <img 
      src="/assets/atelier/antique-compass-rose.png" 
      alt="" 
      class="compass-watermark atelier-engraving-blend" 
      style="
        position: absolute;
        right: -20px;
        bottom: -20px;
        width: 150px;
        height: 150px;
        opacity: 0.14;
        pointer-events: none;
      "
      aria-hidden="true" 
    />
  `;
}
